import { Checkbox } from "antd";
import { FC } from "react";
import { boolean } from "yup";
import classnames from "classnames";
import styles from "./ICheckbox.module.scss";

export interface ICheckboxProps {
  className?: string;
  label?: string | JSX.Element;
  content?: any;
  onChange?;
  disabled?: boolean;
  indeterminate?: boolean;
  checked: boolean;
  value?: any;
}

export const ICheckbox: FC<ICheckboxProps> = ({
  className,
  label,
  content,
  onChange,
  disabled = false,
  indeterminate = false,
  checked,
  value,
}) => {
  return (
    <Checkbox
      value={value}
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      className={classnames(styles.wrapper, {
        [className]: !!className,
        [styles.disabled]: disabled,
        [styles.noLabel]: !label,
      })}
    >
      {label ?? null}
    </Checkbox>
  );
};
